import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {convertToCurrencyFormat} from "./aphQueueUtility";
import {getAphQueueStatusTextByValue} from "./aphQueueConstants";

export const aphCatalogQueueModel = ({
                                         aphCatalogItemId,
                                         aphQueueStatus,
                                         cost,
                                         id,
                                         student,
                                         title
                                     }: Record<string, unknown> = {}) => ({
    aphCatalogItemId,
    details: createAphQueueDetails({
        cost: cost as number | null | undefined,
        aphQueueStatus: aphQueueStatus as string | number | undefined,
        student: student as Record<string, unknown> | null | undefined,
    }),
    id,
    title,
});

export const studentAphQueueModel = ({
                                     queueItemIds,
                                     shippingLocationId = "",
                                     studentId = "",
                                 }: { queueItemIds?: string[]; shippingLocationId?: string; studentId?: string } = {}) => ({
queueItemIds,
    shippingLocationId,
    studentId,
});
export const emptyStudentAphQueueModel = studentAphQueueModel();

function returnCost(cost: number | null | undefined) {
    const hasCost = !isNullOrUndefined(cost);
    return hasCost ? `<div><b>${convertToCurrencyFormat(cost)}</b> (Cost)</div>` : "";
}

function returnAphQueueStatus(queueStatus: string | number | undefined) {
    const hasStatus = !isNullOrUndefined(queueStatus);
    return hasStatus ? `<div><b>${getAphQueueStatusTextByValue(queueStatus)}</b> (Status)</div>` : "";
}

function returnStudent(student: Record<string, unknown> | null | undefined) {
    const hasStudent = !isNullOrUndefined(student);
    return hasStudent ? `<div><b>${createStudent(student)}</b> (Student)</div>` : "";
}

function createStudent(student: Record<string, unknown>) {
    return `${student.firstName || ""} ${student.middleName || ""} ${student.lastName || ""}`;
}

function createAphQueueDetails({cost, aphQueueStatus, student}: { cost?: number | null; aphQueueStatus?: string | number; student?: Record<string, unknown> | null }) {
    let details = "";

    details += returnCost(cost);
    details += returnStudent(student);
    details += returnAphQueueStatus(aphQueueStatus);

    return details;
}